import React from "react";

const RightMarkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <g clipPath="url(#clip0_11770_63830)">
        <circle cx="13" cy="13" r="10" fill="#C6554F" />
        <path
          d="M12.9974 2.16406C7.0174 2.16406 2.16406 7.0174 2.16406 12.9974C2.16406 18.9774 7.0174 23.8307 12.9974 23.8307C18.9774 23.8307 23.8307 18.9774 23.8307 12.9974C23.8307 7.0174 18.9774 2.16406 12.9974 2.16406ZM10.8307 18.4141L5.41406 12.9974L6.94156 11.4699L10.8307 15.3482L19.0532 7.12573L20.5807 8.66406L10.8307 18.4141Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11770_63830">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RightMarkIcon;
